export function formatRate(minimumFractionDigits?: number) {
    return {
        toNumber: (value: string) => {
            const divisor = minimumFractionDigits === 2 ? 100 : minimumFractionDigits === 4 ? 10000 : 1000;
            const floatValue = Number(value.replace(/[.,\s]/gm, "")) / divisor;
            return floatValue;
        },
        toString: (value: number) => {
            return value.toLocaleString('pt-br', {
                minimumFractionDigits: minimumFractionDigits ? minimumFractionDigits : 3
            });
        },
    };
}
